import { SearchOutlined } from "@ant-design/icons";
import { StageNode } from "../model/types/ProjectTree";
import {
  BaseSelect,
  SelectOption,
} from "components/AntDesign/Select/BaseSelect";
import { SelectedItem } from "../model/types/ProjectSelection";

type StageSelectorProps = {
  stages: StageNode[];
  value: SelectedItem[];
  disabled?: boolean;
  onChange: (value: SelectedItem[]) => void;
};

export function StageSelector({
  stages,
  value,
  disabled,
  onChange,
}: StageSelectorProps) {
  const options: SelectOption<number>[] = stages.map((s) => ({
    value: s.id,
    label: s.label,
  }));

  const selectedValue = value[0]?.id;

  const handleChange = (val?: number) => {
    if (val === undefined) {
      onChange([]);
      return;
    }

    const option = options.find((o) => o.value === val);

    onChange([
      {
        id: val,
        label: option?.label ?? "",
      },
    ]);
  };

  return (
    <BaseSelect<number>
      options={options}
      value={selectedValue}
      disabled={disabled}
      prefix={<SearchOutlined />}
      float={{ label: "Select stage" }}
      onChange={handleChange}
    />
  );
}
